"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAsyncConnection = void 0;
const activeAsyncConnection_1 = require("../../../../activeAsyncConnection");
const websocket_helper_1 = require("./websocket.helper");
const polling_helper_1 = require("./polling.helper");
const buildAsyncConnectionConfig = (mode, webSocketConfig, pollingConfig) => ({
    mode,
    webSocketConfig: {
        url: webSocketConfig.url,
    },
    pollingConfig: {
        interval: pollingConfig.interval,
        maxAttempts: pollingConfig.maxAttempts,
        getDataFn: pollingConfig.getDataFn,
    },
});
const openAsyncConnection = async (mode, api, session, progressId, accessTokenFallback, challengeData, onResponse) => {
    const accessToken = session.getData()?.accessToken || accessTokenFallback;
    const webSocketConfig = (0, websocket_helper_1.getWebSocketConfig)(progressId, accessToken);
    const trustedChallengeData = challengeData;
    const pollingConfig = (0, polling_helper_1.getPollingConfig)(api, progressId, trustedChallengeData.biometricId);
    const asyncConnectionConfig = buildAsyncConnectionConfig(mode, webSocketConfig, pollingConfig);
    const asyncConnection = new activeAsyncConnection_1.AsyncConnection(asyncConnectionConfig);
    const connection = asyncConnection.getConnection();
    const asyncConnectionEvents = {
        onReceiveData: pushApproved => {
            if (pushApproved) {
                connection.disconnect();
                onResponse();
            }
        },
        onError: () => null,
    };
    await connection.connect();
    connection.listen(asyncConnectionEvents);
    if (mode === activeAsyncConnection_1.AsyncConnectionMode.WEBSOCKET) {
        connection.send(JSON.stringify(webSocketConfig.request));
    }
    return connection;
};
exports.openAsyncConnection = openAsyncConnection;
//# sourceMappingURL=asyncConnection.helper.js.map